<template>
    <div class="cv-form">
        <form v-if="!isSended" class="cv-form__form" @submit.prevent="onSubmit" >
            <div class="cv-form__common">
                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-input
                            v-model="formValues.surname"
                            name="surname"
                            :placeholder="formTextLocalize.surname"
                            clearable
                            required
                            ref="surnameField"
                        />
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-input
                            v-model="formValues.name"
                            name="firstname"
                            :placeholder="formTextLocalize.firstname"
                            clearable
                            required
                            ref="nameField"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-input
                            v-model="formValues.patronymic"
                            name="patronymic"
                            :placeholder="formTextLocalize.patronymic"
                            clearable
                        />
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-input
                            v-model="formValues.email"
                            name="email"
                            type="email"
                            :placeholder="formTextLocalize.email"
                            clearable
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-default-6 col-v-tablet-12">
                        <z-input
                            v-model="formValues.phone"
                            name="phoneNumber"
                            type="tel"
                            :mask="{mask: '+{7}(000)000-00-00'}"
                            :placeholder="formTextLocalize.phoneNumber"
                            clearable
                            required
                            ref="phoneField"
                        />
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-input
                            v-model="formValues['vacancy-name']"
                            name="vacancy"
                            :placeholder="formTextLocalize.vacancy"
                            required
                            disabled
                            readonly
                            ref="vacancyField"
                        />
                    </div>
                </div>
            </div>
            <z-tabs class="cv-form__tabs" initial-id="fillForm" @change-tab="onTabChange">
                <template #label>
                    <z-tab-label id="fillForm">{{ isHotVacancy ? formTextLocalize.hotFillForm : formTextLocalize.fillForm }}</z-tab-label>
                    <z-tab-label id="attachCV">{{ formTextLocalize.attachCV }}</z-tab-label>
                </template>
                <template #content>
                    <z-tab-content id="fillForm" v-if="!isHotVacancy">
                        <div class="cv-form__block personal">
                            <p class="cv-form__block-title">{{ formTextLocalize.personalInfo }}</p>
                            <div class="row">
                                <div class="col-default-6 col-v-tablet-12">
                                    <z-select
                                        v-model="formValues.gender"
                                        :options="genderSelectOptions"
                                        :placeholder="formTextLocalize.gender"
                                        required
                                        ref="genderField"
                                    />
                                </div>
                                <div class="col-default-6 col-v-tablet-12">
                                    <z-input
                                        v-model="formValues.city"
                                        name="city"
                                        :placeholder="formTextLocalize.city"
                                        clearable
                                        required
                                        ref="cityField"
                                    />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-default-6 col-v-tablet-12">
                                    <z-date-picker
                                        v-model="formValues['birth-date']"
                                        :placeholder="formTextLocalize.bDay"
                                        required
                                        ref="bDayField"
                                    />
                                </div>
                                <div class="col-default-6 col-v-tablet-12">
                                    <z-input
                                        v-model="formValues.nationality"
                                        name="nationality"
                                        :placeholder="formTextLocalize.nationality"
                                        clearable
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="cv-form__block experience">
                            <p class="cv-form__block-title">{{ formTextLocalize.experience }}</p>
                            <z-checkbox
                                v-model="formValues.experience[0]['no-experience']"
                                :data="{
                                    text: formTextLocalize.noExperience,
                                    id: 'no-experience'
                                }"
                                size="l"
                                class="cv-form__experience-checkbox"
                            />
                            <template
                                v-if="!formValues.experience[0]['no-experience']"
                            >
                                <div
                                    v-for="(experience, index) in formValues.experience"
                                    :key="index"
                                    class="cv-form__experience"
                                >
                                    <div class="row">
                                        <div class="col-default-4 col-v-tablet-12">
                                            <z-date-picker
                                                v-model="experience.start"
                                                :placeholder="formTextLocalize.start"
                                                type="month"
                                                format="MM.YYYY"
                                            />

                                        </div>
                                        <div
                                            v-if="!experience.current"
                                            class="col-default-4 col-v-tablet-12">
                                            <z-date-picker
                                                v-model="experience.end"
                                                :placeholder="formTextLocalize.end"
                                                type="month"
                                                format="MM.YYYY"
                                            />
                                        </div>
                                        <div class="col-default-4 col-v-tablet-12 align-self-center">
                                            <z-checkbox
                                                v-model="experience.current"
                                                :data="{
                                                    text: formTextLocalize.until,
                                                    id: 'until-now'
                                                }"
                                                size="m"
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-default-12">
                                            <z-input
                                                v-model="experience['company-name']"
                                                name="company-name"
                                                :placeholder="formTextLocalize.company"
                                                clearable
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-default-12">
                                            <z-input
                                                v-model="experience.position"
                                                name="position"
                                                :placeholder="formTextLocalize.position"
                                                clearable
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-default-12">
                                            <z-textarea
                                                v-model="experience.achievements"
                                                :placeholder="formTextLocalize.achievements"
                                                name="achievements"
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div
                                            v-if="formValues.experience.length > 1 && index !== 0"
                                            class="col-default-12"
                                        >
                                            <z-button
                                                type="button" @click="removeData('experience',index)"
                                                class="cv-form__delete"
                                                size="s"
                                                kind="secondary"
                                            >
                                                {{ formTextLocalize.delete }}
                                            </z-button>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-default-12">
                                        <z-button
                                            type="button"
                                            @click="addMoreWorkPlace"
                                            class=cv-form__add-button
                                            size="s"
                                            kind="primary"
                                        >
                                            {{ formTextLocalize.addMore }}
                                        </z-button>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div class="cv-form__block education">
                            <p class="cv-form__block-title">{{ formTextLocalize.education }}</p>
                            <div
                                v-for="(educationPlace, index) in formValues.education"
                                :key="index"
                                class="cv-form__experience"
                            >
                                <div class="row">
                                    <div class="col-default-12">
                                        <z-input
                                            v-model="educationPlace.institution"
                                            name="educationalInstitution"
                                            :placeholder="formTextLocalize.educationalInstitution"
                                            clearable
                                        />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-default-12">
                                        <z-input
                                            v-model="educationPlace.specialization"
                                            name="speciality"
                                            :placeholder="formTextLocalize.speciality"
                                            clearable
                                        />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-default-12">
                                        <z-date-picker
                                            v-model="educationPlace['graduation-year']"
                                            :placeholder="formTextLocalize.graduationYear"
                                            type="year"
                                            format="YYYY"
                                        />
                                    </div>
                                </div>
                                <div v-if="formValues.education.length > 1 && index !== 0" class="row">
                                    <div

                                        class="col-default-6 col-v-tablet-12"
                                    >
                                        <z-button
                                            type="button"
                                            @click="removeData('education',index)"
                                            class="cv-form__delete"
                                            size="s"
                                            kind="secondary"
                                        >
                                            {{ formTextLocalize.delete }}
                                        </z-button>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-default-12">
                                    <z-button
                                        type="button"
                                        @click="addMoreEducationPlace"
                                        class=cv-form__add-button
                                        size="s"
                                        kind="primary"
                                    >
                                        {{ formTextLocalize.addMoreInstitution }}
                                    </z-button>
                                </div>
                            </div>
                            <div class="row cv-form__education-additional">
                                <div class="col-default-12">
                                    <z-input
                                        v-model="formValues['add-qualifications']"
                                        name="additionalQualifications"
                                        :placeholder="formTextLocalize.additionalQualifications"
                                        clearable
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="cv-form__block additional-info">
                            <p class="cv-form__block-title">{{ formTextLocalize.additional }}</p>
                            <div class="row">
                                <div class="col-default-12">
                                    <z-textarea
                                        v-model="formValues.skills"
                                        name="skills"
                                        :placeholder="formTextLocalize.skills"
                                        clearable
                                    />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-default-12">
                                    <z-textarea
                                        v-model="formValues['add-info']"
                                        name="add-info"
                                        :placeholder="formTextLocalize.additional"
                                        clearable
                                    />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-default-12">
                                    <z-select
                                        v-model="formValues['how-know']"
                                        :options="howKnow"
                                        :placeholder="formTextLocalize.howKnow"
                                        clearable
                                        required
                                        ref="howKnowField"
                                    />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-default-12">
                                    <z-select
                                        v-model="formValues['reason-choose']"
                                        :options="reasonChoose"
                                        :placeholder="formTextLocalize.reasonChoose"
                                        required
                                        clearable
                                        ref="reasonChooseField"
                                    />
                                </div>
                            </div>
                        </div>
                    </z-tab-content>
                    <z-tab-content id="attachCV">
                        <div class="cv-form__block resume">
                            <p class="cv-form__block-title">{{ formTextLocalize.resume }}</p>
                            <div class="row">
                                <div class="col-default-12">
                                    <z-input-file
                                        name="resume"
                                        accept=".doc, .docx, .pdf, .rtf, .jpeg, .jpg"
                                        size="m"
                                        required
                                        ref="fileField"
                                        :max-size="20971520"
                                        :show-accept-label="true"
                                        @change="updateFileField"
                                    />
                                </div>
                            </div>
                        </div>
                    </z-tab-content>

                </template>
            </z-tabs>
            <div class="cv-form__block agreement" :class="{'u-mt-s': isHotVacancy}">
                <div class="row">
                    <div class="col-default-12">
                        <z-checkbox
                            :data="{
                                text: formTextLocalize.agreement,
                                id: 'agreement'
                            }"
                            size="m"
                            required
                            ref="agreementField"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-default-12">
                        <z-checkbox
                            :data="{
                                text: formTextLocalize.agreementTwo,
                                id: 'agreementTwo'
                            }"
                            size="m"
                            required
                            ref="agreementTwoField"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-default-12">
                        <p class="cv-form__notification">
                            * - регламентируется главой 14 Трудового кодекса РФ, Федеральным Законом от 7.07.2006 года № 152-ФЗ «О персональных данных» в редакции Федерального закона от 25.07.2011 г. № 261-ФЗ.
                        </p>
                    </div>
                </div>
                <div class="row">

                    <div class="col-default-12">
                        <p class="cv-form__notification">
                            Поля, помеченные * обязательны для заполнения
                        </p>
                        <z-button
                            type="submit"
                            class="cv-form__submit"
                        >
                            {{ formTextLocalize.submit }}
                        </z-button>

                        <p class="text-size-s border-error-text u-mt-2xs" v-if="errorMsg" v-html="errorMsg"></p>
                    </div>
                </div>
            </div>
        </form>

        <div class="text-size-m" v-else>
            <p class="text-size-xl u-mb-s u-semi-bold">Добрый день, уважаемый&nbsp;соискатель!</p>
            <p>Благодарим вас за&nbsp;интерес к&nbsp;вакансиям нашей компании.</p>
            <p>Мы получили ваше резюме и сейчас оно находится на рассмотрении. Для&nbsp;принятия решения нам потребуется <b>10&nbsp;рабочих&nbsp;дней</b> и&nbsp;мы&nbsp;будем готовы вернуться к&nbsp;общению с&nbsp;вами в&nbsp;случае положительного результата по&nbsp;итогам его&nbsp;рассмотрения.</p>
            <p><b>Если в&nbsp;течение этого периода вы&nbsp;не&nbsp;получите обратную связь</b> от&nbsp;нас, это значит, что мы включили резюме в&nbsp;базу потенциальных кандидатов и&nbsp;будем готовы продолжить общение с&nbsp;вами после открытия подходящей вакансии.</p>
            <p>Желаем вам&nbsp;удачи в&nbsp;трудоустройстве и&nbsp;построении карьеры!</p>
            <p class="text-size-xl u-mb-s u-mt-s u-semi-bold">С уважением,<br>команда центра кадрового обеспечения&nbsp;ИНК</p>
            <p class="u-mt-3xl">Полная и&nbsp;актуальная информация о&nbsp;вакансиях&nbsp;ИНК всегда на&nbsp;нашем <a href="/career/vacancies/">сайте</a>.</p>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useGetter } from '@/composable/useGetter'
import { ZTabs, ZTabContent, ZTabLabel } from '@/components/ZTabs';
import { sendCV } from '@/api/sendCV';
import { genderSelectOptions, formTextLocalize, reasonChoose, howKnow } from './static';
import { useRecaptcha } from '@/composable/useRecaptcha'

const {app} = useGetter(['app'])
const { initGRecaptcha, getRecaptchaToken } = useRecaptcha()

defineProps({
    title: {
        type: String,
        default: formTextLocalize.title,
        comment: 'Заголовок формы'
    },
    text: {
        type: String,
        default: '',
        comment: 'Текст формы'
    }
})

const isSended = ref(false)
const errorMsg = ref('')
const isHotVacancy = ref(false);
const nameField = ref(null)
const surnameField = ref(null)
const phoneField = ref(null)
const vacancyField = ref(null)
const cityField = ref(null)
const fileField = ref(null)
const bDayField = ref(null)
const agreementField = ref(null)
const agreementTwoField = ref(null)
const reasonChooseField = ref(null)
const genderField = ref(null)
const howKnowField = ref(null)
const formValues = ref({
    'vacancy-name': '',
    'vacancy-id': '',
    'surname': '',
    'name': '',
    'patronymic': '',
    'email': '',
    'phone': '',
    'gender': '',
    'city': '',
    'birth-date': '',
    'nationality': '',
    'file': '',
    'education': [
        {
            'institution': '',
            'specialization': '',
            'graduation-year': '',
        }
    ],
    'experience': [
        {
            'no-experience': false,
            'start': '',
            'end': '',
            'current': false,
            'company-name': '',
            'position': '',
            'achievements': '',
        },
    ],
    'add-qualifications': '',
    'last-position': '',
    'skills': '',
    'add-info': '',
    'how-know': '',
    'reason-choose': '',
})

const updateFileField = (file) => {
    formValues.value.file = file?.[0]
}

const fillFormRequiredElements = [nameField, surnameField, phoneField, vacancyField, cityField, bDayField, genderField, howKnowField, agreementField, agreementTwoField, reasonChooseField];
const hotFillFormRequiredElements = [nameField, surnameField, phoneField, vacancyField, agreementField, agreementTwoField];
const attachCVRequiredElements = [nameField, surnameField, phoneField, vacancyField, fileField, agreementField, agreementTwoField]
let currentTab = 'tabs-fillForm';

const addMoreWorkPlace = () => {
    formValues.value.experience.push({
        'no-experience': false,
        'start': '',
        'end': '',
        'current': false,
        'company-name': '',
        'position': '',
        'achievements': '',

    })
}

const addMoreEducationPlace = () => {
    formValues.value.education.push({
        'institution': '',
        'specialization': '',
        'graduation-year': '',
    })
}

const removeData = (field, index) => {
    formValues.value[field].splice(index, 1)
}
const updateBooleanValues = (obj) => {
    for (let key in obj) {
        if (typeof obj[key] === 'boolean') {
            obj[key] = obj[key] ? 'Y' : '';
        } else if (typeof obj[key] === 'object') {
            updateBooleanValues(obj[key]);
        }
    }
    return obj
};
const buildFormData = (data) => {
    let formData = new FormData()
    for (let key in data) {
        if (data.hasOwnProperty(key)) {
            if (Array.isArray(data[key])) {
                for (let value in data[key]) {
                    if (key === 'education' || key === 'experience') {
                        formData.append(key + '[]', JSON.stringify(data[key][value]))
                    } else {
                        formData.append(key + '[]', data[key][value])
                    }
                }
            } else {
                formData.append(key, data[key])
            }
        }
    }
    return formData
}

const onTabChange = (data) => {
    currentTab = data
}

const onSubmit = async () => {
    const requiredFields = currentTab === 'tabs-fillForm' ? (isHotVacancy.value ? hotFillFormRequiredElements : fillFormRequiredElements) : attachCVRequiredElements
    let isValid = true

    let btnSend = document.querySelector('.cv-form__submit');
    if (btnSend.classList.contains('z-button--loading')) return

    requiredFields.forEach(item => {
        if (item.value) {
            item.value?.validate()
            if (item.value.error) {
                isValid = false
            }
        }
    })

    if (!isValid) return

    btnSend.classList.add('z-button--loading');

    try {
        const recaptchaToken = await getRecaptchaToken()

        if (!recaptchaToken) {
            throw new Error('Failed to get reCAPTCHA token');
        }

        formValues.value.captcha = recaptchaToken
        sendForm()
    } catch (error) {
        console.error(error)
    }
}

const sendForm = () => {
    const preparedData = updateBooleanValues(formValues.value);
    // preparedData["vacancy-name"] =  preparedData["vacancy-id"] ? '' : formValues.value["vacancy-name"]
    sendCV(buildFormData(preparedData))
        .then(data => {
            if (data.status === 'error') {
                errorMsg.value = data.message
            } else {
                isSended.value = true
            }
        })
        .catch(e => {
            console.log(e);
            errorMsg.value = formTextLocalize.sendError
        })
    document.querySelector('.cv-form__submit').classList.remove('z-button--loading');;
}

onMounted(()=> {
    const urlParams = new URLSearchParams(window.location.search);
    const vacancyId = urlParams.get('vacancy-id');
    const vacancyName = urlParams.get('name');
    const hot = urlParams.get('hot');

    if(hot === 'Y') {
        isHotVacancy.value = true;
    }

    if (vacancyName) {
        formValues.value['vacancy-name'] = vacancyName
    }

    if(vacancyId){
        formValues.value['vacancy-id'] = vacancyId
    }

    initGRecaptcha()
})
</script>

<style lang="scss" scoped>
.cv-form {
    &__text {
        margin: 0;
        @include typo-level(S);
    }

    &__tabs {
        @include margin-level(top, M);
    }

    &__block {
        @include margin-level(bottom, M);

        &-title {
            @include margin-level(top, XS);
            @include margin-level(bottom, XS);
            @include typo-level(Xl);
        }
    }

    &__experience {
        &:not(:first-of-type){
            margin-top: var(--spacer-s);
            padding-top: var(--spacer-s);
            border-top: 1px solid var(--color-black-20);
        }
        &-checkbox {
            @include margin-level(top, M)
        }
    }

    &__add-button {
        @include margin-level(top, M);
        margin-left: auto;
        display: flex;
    }

    &__education {
        &:not(:first-of-type){
            margin-top: var(--spacer-s);
            padding-top: var(--spacer-s);
            border-top: 1px solid var(--color-black-20);
        }
        &-additional {
            @include margin-level(top, M);
        }
    }

    &__notification{
        margin: 0;
        @include typo-level(S);
    }

    &__submit{
        @include margin-level(top, 2XS)
    }

    & .align-self-center{
        align-self: center;
    }
}
</style>
